import { notification } from 'antd'
import { API, graphqlOperation } from 'aws-amplify'
import React, { useState, useEffect } from 'react'

import Layout from '../Layout'
import ContactTable from './Table'
import { listContactUss } from '../../graphql/queries'

const ContactUs = () => {
  const [contacts, setContacts] = useState([])
  const [loading, setLoading] = useState(true)

  const getContacts = async () => {
    try {
      const { data } = await API.graphql(graphqlOperation(listContactUss))
      const { items } = data.listContactUss
      const listOfItems = items
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .map((a, index) => ({ ...a, sn: index + 1 }))
      setLoading(false)
      setContacts(listOfItems)
    } catch (error) {
      notification.error({
        description: error?.errors ? error?.errors[0].message : 'Something went wrong'
      })
      setLoading(false)
    }
  }

  useEffect(() => {
    getContacts()
  }, [])

  return (
    <Layout>
      <main className='w-full flex-grow p-4'>
        <h2 className='text-2xl pb-4 flex items-center px-10 font-bold'>
          <i className='fas fa-list mr-3' /> Contact us Requests
        </h2>
        <ContactTable loading={loading} info={contacts} />
      </main>
    </Layout>
  )
}

export default ContactUs
